import React from 'react';
import { WishlistDetails } from '../features/wishlist/WishlistDetails';
export function WishlistPage() {
    return React.createElement(WishlistDetails, null);
}
